import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConfigurationService, CustomerService, DebtorService, InvoicesService } from '../_services';
import { AppConfig } from '../_helpers/index';
import * as XLSX from 'xlsx';
import * as Excel from "exceljs/dist/exceljs.min.js";
import { AccountImport } from '../_models';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { CurrencyPipe } from '@angular/common';
import { Invoice, Account, Debtor, Amount, Order, User } from '../_models';
import * as fs from 'file-saver';

@Component({
  selector: 'paymentinvoiceimport',
  templateUrl: './paymentinvoiceimport.component.html',
  styleUrls: ['./payout-invoice-import-process/old-payout-invoice-import-version/old-payout-invoice-import-version.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class PaymentInvoiceImportComponent implements OnInit {
  uploadedFileName: any;
  tab1ActiveStatus: any;
  tab2ActiveStatus: any;
  tab3ActiveStatus: any;
  tab1Visibility: any;
  tab2Visibility: any;
  tab3Visibility: any;
  customerPuplic_key: any;
  user_public_id: any;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  userNameProcess: string;
  userEmail: string;
  searchFilterForm: FormGroup;
  enableImportExcel: boolean;
  data = [];
  errorImport: string;
  excelHeader: any;
  excelheaderFormat = ['ID ORDEN DE PAGO', 'REFERENCIA', 'NOMBRE', 'DESCRIPCION', 'ID CLIENTE (*)', 'EMAIL DEL CLIENTE (*)', 'MONEDA', 'MONTO', 'VENCIMIENTO', 'EXPIRACION'];
  hiddenRow = [];
  hiddenRowCount = 0;
  hiddenColumn = [];
  hiddenColumnCount = 0;
  excelColumnNameAndLetter = [];
  excelAvailableColumn = [];
  missingExcelColumns = [];
  excelInvalidColumn = [];
  excelInvalidColumnLetter = [];
  keyValuesChange = {
    'ITEM': "item",
    'ID ORDEN DE PAGO': 'external_id',
    'REFERENCIA': 'order_id',
    'NOMBRE': 'name',
    'DESCRIPCION': 'order_description',
    'ID CLIENTE (*)': 'clientid',
    'EMAIL DEL CLIENTE (*)': 'clientemail',
    'MONEDA': 'currency',
    'MONTO': 'value',
    'VENCIMIENTO': 'due_datetime',
    'EXPIRACION': 'expiration_datetime',
  };
  keyChangedData = [];
  arrFinalData = [];
  @ViewChild('invoicePaginator', { read: MatPaginator }) invoicePaginator: MatPaginator;
  @ViewChild('invoicePaginator1', { read: MatPaginator }) invoicePaginator1: MatPaginator;
  excelRowsFetchedCount: any;
  excelRowsProcessedCount: any;
  excelRowsNotProcessedCount: any;
  dataSource: any;
  pageSize: number;
  PageSizeOptions: number[];
  displayedColumns: string[] = ['item', 'external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime'];
  tab3Error: boolean;
  columnErrorCount = 0;
  rowErrorCount = 0;
  invalidDataArray: any;
  invalidDataSource: any;
  obsInvalidData: Observable<any>;
  customerList = [];
  rowNotProcessedCount = 0;
  rowProcessedCount = 0;
  arrFinalDataWithStatus = [];
  tempExcelHeader = [];
  allowedDateFormats = ['DD/MM/YYYY', 'D/M/YYYY', 'DD/MM/YY', 'D/M/YY'];
  errMessage: string;
  invoiceStatusFail: boolean = false;

  baseURL: string;

  constructor(private router: Router, private formBuilder: FormBuilder
    , private spinnerService: Ng4LoadingSpinnerService
    , private excelService: ExcelService
    , private customerService: CustomerService
    , private debtorService: DebtorService
    , private invoicesService: InvoicesService) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.baseURL = AppConfig.settings.apiServer.baseURL+'processes/processimport';
  }

  ngOnInit() {
    var tempBrowserStorage;

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customerPuplic_key = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');
        this.userNameProcess = localStorage.getItem('username');
        this.userEmail = localStorage.getItem('userEmail');
      }
    }
    else {
      this.customerPuplic_key = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }

    tempBrowserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof tempBrowserStorage.getItem('timezone') === 'undefined') ? null : tempBrowserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {

      this.offsetTimeZone = tempBrowserStorage.getItem('timezone');
      this.offsetMinutes = 0;

      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    this.InitialSetup();
    this.GetCustomerDetails();
  }

  downloadSampleFile() {
    //location.href = 'assets/helpfiles/InvoiceImport.xlsx?v='+ moment(new Date()).format('YYYYMMDDHHmm');
    var url = 'assets/helpfiles/InvoiceImport.xlsx?v='+ moment(new Date()).format('YYYYMMDDHHmm');
    var fileName = "InvoiceImport.xlsx";
    this.customerService.downloadTemplatefile(url).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob], fileName, { type: res.body.type });
      fs.saveAs(file);
    },
      error => {
        console.log('Failed while trying to the download the file. ' + error.error);
      })
  }

  InitialSetup() {
    this.tab1();
    this.dataSource = new MatTableDataSource();
    this.tab3Error = false;
  }

  tab1() {
    this.searchFilterForm = this.formBuilder.group({
      edt: ['']
    });
    this.enableImportExcel = false;
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = false;
    this.tab2Visibility = true;
    this.tab3Visibility = true;
    this.uploadedFileName = "Archivo a subir";
    window.scroll(0, 0);
    this.InitFileChange();
  }

  tab2() {
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = true;
    this.tab1ActiveStatus = "disabled";
    this.tab2ActiveStatus = "active";
    this.tab3ActiveStatus = "disabled";
    window.scroll(0, 0);
  }

  tab3() {
    this.tab1Visibility = true;
    this.tab2Visibility = true;
    this.tab3Visibility = false;
    this.tab1ActiveStatus = "disabled";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "active";
    window.scroll(0, 0);
  }

  Executeagain() {
    this.InitialSetup();
  }


  InitFileChange() {
    this.data = [];
    this.hiddenRow = [];
    this.hiddenRowCount = 0;
    this.hiddenColumn = [];
    this.hiddenColumnCount = 0;
    this.excelColumnNameAndLetter = [];
    this.excelAvailableColumn = [];
    this.missingExcelColumns = [];
    this.excelInvalidColumn = [];
    this.excelInvalidColumnLetter = [];
    this.arrFinalData = [];
    this.keyChangedData = [];
    this.columnErrorCount = 0;
    this.rowErrorCount = 0;
    this.invalidDataArray = [];
    this.invalidDataSource = new MatTableDataSource();
    this.excelRowsFetchedCount = Number(0);
    this.excelRowsProcessedCount = Number(0);
    this.excelRowsNotProcessedCount = Number(0);
    this.excelHeader = [];
    this.obsInvalidData = this.invalidDataSource.connect();
    this.rowNotProcessedCount = 0;
    this.rowProcessedCount = 0;
    this.arrFinalDataWithStatus = [];
    this.tempExcelHeader = [];
  }


  ngAfterViewInit() {
    this.invoicePaginator._intl.itemsPerPageLabel = "Registros por página";
    this.invoicePaginator._intl.nextPageLabel = "siguiente página";
    this.invoicePaginator._intl.lastPageLabel = "última página";
    this.invoicePaginator._intl.previousPageLabel = "anterior página";
    this.invoicePaginator._intl.firstPageLabel = "primera página";

    this.invoicePaginator1._intl.itemsPerPageLabel = "Registros por página";
    this.invoicePaginator1._intl.nextPageLabel = "siguiente página";
    this.invoicePaginator1._intl.lastPageLabel = "última página";
    this.invoicePaginator1._intl.previousPageLabel = "anterior página";
    this.invoicePaginator1._intl.firstPageLabel = "primera página";
  }

  OnFileChange(evt: any) {
    this.InitFileChange();
    let jsonData = null;
    let workBook = null;
    let sheet = [];
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length > 1) throw new Error('Cannot use multiple files');
    if (target.files.length === 1) {
      this.checkHiddenRowAndColumns(target.files[0]);
      const file = target.files[0];
      this.searchFilterForm.get('edt').setValue(file);
      this.uploadedFileName = target.files[0].name;

      if (target.files.length == 1 && (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary',cellText:false ,cellDates:true});
          jsonData = workBook.SheetNames.reduce((initial, name) => {
            const sheet = workBook.Sheets[name];
            initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false, blankrows: false, dateNF:'DD/MM/YYYY' })
            .map(row =>
              Object.keys(row).reduce((obj, key) => {
                obj[key.trim()] = row[key];
                return obj;
              }, {})
            );
            return initial;
          }, {});
          var sheet = Object.keys(jsonData);
          if (sheet.length > 0) {
            this.data = jsonData[sheet[0]];
          } else {
            this.data = [];
          }
          this.enableImportExcel = true;
        };
        reader.readAsBinaryString(target.files[0]);
      }
      else {
        this.enableImportExcel = false;
        this.errorImport = "Error al intentar abrir el archivo ! ";
      }
    } else {
      this.uploadedFileName = "Archivo a subir";
    }
  }

  checkHiddenRowAndColumns(file) {
    const workbook = new Excel.Workbook();
    const arryBuffer = new Response(file).arrayBuffer();

    arryBuffer.then((data) => {
      workbook.xlsx.load(data)
        .then(() => {
          const worksheet = workbook.getWorksheet(1);
          this.spinnerService.hide();
          var name;
          var k = 0;
          //check hidden columns
          for (var i = 0; i < worksheet.columns.length; i++) {
            if (worksheet.columns[i].hidden == true) {
              this.hiddenColumn.push(worksheet.columns[i].letter);
              this.hiddenColumnCount++;
            }
            if (worksheet.columns[i].values.length > 0) {
              name = worksheet.columns[i].values[1];
            } else {
              //for empty header
              if (k == 0) {
                name = "__EMPTY";
                k++;
              }
              else if (k > 0) {
                name = "__EMPTY_" + k;
                k++;
              }
            }
            if (!name.includes("__EMPTY")) {
              this.excelColumnNameAndLetter.push(
                {
                  "letter": worksheet.columns[i].letter,
                  "name": name,
                  "hidden": worksheet.columns[i].hidden
                }
              );
            }
          }

          //check hidden row
          worksheet.eachRow((row) => {
            if (row.hidden == true) {
              this.hiddenRow.push(row.number);
              this.hiddenRowCount++;
            }
          });

        });
    });
  }

  import() {
    this.spinnerService.show();
    this.enableImportExcel = false;
    this.importExcelData();
  }

  //   check the excel header column format & missing column & invalid column name
  checkExcelHeader() {
    for (var i = 0; i < this.excelheaderFormat.length; i++) {
      for (var j = 0; j < this.excelHeader.length; j++) {
        if (this.excelheaderFormat[i] === this.excelHeader[j]) {
          this.excelAvailableColumn.push(this.excelheaderFormat[i]);
        }
      }
    }
    this.missingExcelColumns = this.excelheaderFormat.filter(item => this.excelAvailableColumn.indexOf(item) < 0);
    if (this.missingExcelColumns.length == 0) {
      if (this.excelheaderFormat.length !== this.excelHeader.length) {
        this.excelInvalidColumn = this.excelHeader.filter(item => this.excelheaderFormat.indexOf(item) < 0);
      }
    }
  }

  //get the Invalid column excel letter
  getInvalidColumnLetter() {
    let tempValue;
    tempValue = this.excelColumnNameAndLetter.filter(item => this.excelInvalidColumn.some(f => f == item.name));
    tempValue.forEach(element => {
      if (element.hidden == false) {
        this.excelInvalidColumnLetter.push(element.letter)
      }
    });
  }

  importExcelData() {
    this.tempExcelHeader = Object.keys(this.data[0]);
    //this.excelHeader = Object.keys(this.data[0]);
    // this.excelHeader.forEach(function(item, index, object) {
    //   if (item.includes("__EMPTY")) {
    //     object.splice(index, 1);
    //   }
    // });

    for (var x = 0; x < this.tempExcelHeader.length; x++) {
      if (!this.tempExcelHeader[x].includes("__EMPTY")) {
        this.excelHeader.push(this.tempExcelHeader[x])
      }
    }

    this.checkExcelHeader()
    this.getInvalidColumnLetter();
    if (this.excelAvailableColumn.length == 10) {

      //add the item column and row number
      var k = 1
      this.data.forEach(element => {
        element['ITEM'] = k;
        k++
      });

      //change the key value
      this.data.forEach(element => {
        let mapped = Object.keys(element).reduce((item, key) => {
          item[this.keyValuesChange[key]] = element[key];
          return item;
        }, {});
        this.keyChangedData.push(mapped);
      });

      for (var i = 0; i < this.keyChangedData.length; i++) {
        var object_temp = this.keyChangedData[i];
        var dataError = [];
        var dataInvalidError = [];

        //validate the ID ORDEN DE PAGO column value
        if (object_temp['external_id'] != '' && object_temp['external_id'] != null && object_temp['external_id'] != undefined) {
          if (object_temp['external_id'].length > 32) {
            object_temp['external_id'] = 'Dato inválido';
            dataInvalidError.push("ID ORDEN DE PAGO");
          }
        } else {
          object_temp['external_id'] = 'Dato inválido';
          dataError.push("ID ORDEN DE PAGO");
        }

        //validate the REFERENCIA column value
        if (object_temp['order_id'] == '' || object_temp['order_id'] == null || object_temp['order_id'] == undefined) {
          object_temp['order_id'] = 'Dato inválido';
          dataError.push("REFERENCIA");
        }

        //validate the NOMBRE column value
        if (object_temp['name'] == '' || object_temp['name'] == null || object_temp['name'] == undefined) {
          object_temp['name'] = 'Dato inválido';
          dataError.push("NOMBRE");
        }

        //validate the DESCRIPCION column value
        if (object_temp['order_description'] == '' || object_temp['order_description'] == null || object_temp['order_description'] == undefined) {
          object_temp['order_description'] = 'Dato inválido';
          dataError.push("DESCRIPCION");
        }

        //validate the ID CLIENTE column value
        if (object_temp['clientid'] == '' || object_temp['clientid'] == null || object_temp['clientid'] == undefined) {
          object_temp['clientid'] = 'Dato inválido';
          dataError.push("ID CLIENTE");
        }

        //validate the EMAIL DEL CLIENTE column value
        if (object_temp['clientemail'] != '' && object_temp['clientemail'] != null && object_temp['clientemail'] != undefined) {
          if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(object_temp['clientemail'].trim()))) {
            object_temp['clientemail'] = 'Dato inválido';
            dataInvalidError.push("EMAIL DEL CLIENTE")
          }
        } else {
          object_temp['clientemail'] = 'Dato inválido';
          dataError.push("EMAIL DEL CLIENTE");
        }

        //validate the MONEDA column value
        if (object_temp['currency'] != '' && object_temp['currency'] != null && object_temp['currency'] != undefined) {
          switch (object_temp['currency'].trim()) {
            case 'PEN':
              break;
            case 'USD':
              break;
            default:
              object_temp['currency'] = 'Dato inválido';
              dataInvalidError.push("MONEDA")
          }
        } else {
          object_temp['currency'] = 'Dato inválido';
          dataError.push('MONEDA');
        }

        //validate the MONTO column value
        // if (object_temp['value'] != '' && object_temp['value'] != null && object_temp['value'] != undefined) {
        //   if (isNaN(object_temp["value"].trim())) {
        //     object_temp["value"] = 'Dato inválido';
        //     dataInvalidError.push("MONTO");
        //   } else {
        //     if (!(/^\d+(?:\.\d{0,2})$/).test(object_temp['value'])) {
        //       object_temp["value"] = 'Dato inválido';
        //       dataInvalidError.push("MONTO");
        //     }
        //   }
        // }
        // else {
        //   object_temp["value"] = 'Dato inválido';
        //   dataError.push("MONTO");
        // }

       // validate the MONTO column value
        if (object_temp['value'] != '' && object_temp['value'] != null && object_temp['value'] != undefined) {
          if (isNaN(object_temp["value"].trim())) {
            object_temp["value"] = 'Dato inválido';
            dataInvalidError.push("MONTO");
          } else {
            object_temp['value'] = this.convertToDecimal(object_temp['value'])
            if (!(/^\d+(?:\.\d{0,2})$/).test(object_temp['value'])) {
              object_temp["value"] = 'Dato inválido';
              dataInvalidError.push("MONTO");
            }
            
          }
        }
        else {
          object_temp["value"] = 'Dato inválido';
          dataError.push("MONTO");
        }

        if (object_temp["due_datetime"] != '' && object_temp["due_datetime"] != null && object_temp["due_datetime"] != undefined) {
          var vencimiento = moment(object_temp["due_datetime"].trim(),this.allowedDateFormats,true);
          if (!vencimiento.isValid()) {
            object_temp["due_datetime"] = "Dato inválido";
            dataInvalidError.push("VENCIMIENTO");
          }
        }
        else {
          object_temp["due_datetime"] = 'Dato inválido';
          dataError.push("VENCIMIENTO");
        }

        if (object_temp["expiration_datetime"] != '' && object_temp["expiration_datetime"] != null && object_temp["expiration_datetime"] != undefined) {
          var expiration = moment(object_temp["expiration_datetime"].trim(),this.allowedDateFormats,true);
          if (!expiration.isValid()) {
            object_temp["expiration_datetime"] = "Dato inválido";
            dataInvalidError.push("EXPIRACION");
          }
        }
        else {
          object_temp["expiration_datetime"] = 'Dato inválido';
          dataError.push("EXPIRACION");
        }

        if (dataError.length > 0 && dataError.length < 8) {
          this.columnErrorCount++;
        }

        if (dataError.length > 8) {
          this.rowErrorCount++;
        }

        if (dataInvalidError.length > 0) {
          this.columnErrorCount++;
        }

        object_temp["dataError"] = dataError.length > 8 ? null : dataError;
        object_temp["dataInvalidError"] = dataInvalidError;
        object_temp["rowError"] = dataError.length > 8 ? dataError : null;
        this.arrFinalData.push(object_temp);
      }
      this.checkValidAndInvalidData();
      this.excelRowsFetchedCount = this.arrFinalData.length;
      this.dataSource.paginator = this.invoicePaginator;
      this.dataSource.data = this.arrFinalData;
      this.invalidDataSource.data = this.invalidDataArray;
      this.invalidDataSource.paginator = this.invoicePaginator1;
      this.obsInvalidData = this.invalidDataSource.connect();
      this.spinnerService.hide();
      this.tab2();
    }
    else {
      this.tab3Error = true;
      this.tab3();
      this.spinnerService.hide();
    }
  }

  convertToDecimal(value) { 
    var n = Number.parseFloat(value);
    if(!value || isNaN(n) || n < 0) return 0;
    return n.toFixed(2);
  }

  ngOnDestroy() {
    if (this.invalidDataSource) { 
      this.invalidDataSource.disconnect(); 
    }
  }
  
  checkValidAndInvalidData() {
    for (var i = 0; i <= this.arrFinalData.length - 1; i++) {
      var debtorobj = this.arrFinalData[i];
      var exists = Object.keys(debtorobj).some(function (k) {
        return debtorobj[k] === "Dato inválido";
      });
      if (exists == true) {
        this.invalidData(debtorobj);
      } else if (exists == false) {
        this.validData(debtorobj);
      }
    }
  }

  invalidData(data) {
    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.invalidDataArray.push(data);
  }
  validData(data) {
    this.excelRowsProcessedCount = this.excelRowsProcessedCount + 1;
  }

  confirmData() {
    this.spinnerService.show();

    this.arrFinalData.forEach(element => {
      delete element.dataError;
      delete element.dataInvalidError;
      delete element.item;
      delete element.rowError;
    })

    for (var i = 0; i <= this.arrFinalData.length - 1; i++) {      
      var tempCustomerList = this.customerList.filter(item => item.email == this.arrFinalData[i].clientemail && item.external_id == this.arrFinalData[i].clientid);
      var tempCustomerStatus = false;
      if (tempCustomerList.length > 0) {
        for (var k = 0; k < tempCustomerList.length; k++) {
          if (tempCustomerList[k].status == "INACTIVE") {
            tempCustomerStatus = true;
          }
        }
      }

      if (this.arrFinalData[i].due_datetime == "Dato inválido" || this.arrFinalData[i].expiration_datetime == "Dato inválido") {

        this.failureInvoiceDetails("Invalid Date", this.arrFinalData[i],i);
      }
      else if (this.arrFinalData[i].due_datetime == "Dato inválido" && this.arrFinalData[i].expiration_datetime == "Dato inválido") {
        this.failureInvoiceDetails("Invalid Date", this.arrFinalData[i],i);
      }
      else if (tempCustomerStatus) {
        this.failureInvoiceDetails("InActive Customer", this.arrFinalData[i],i);
      }
      else {
        const debtorPromiseResult = this.debtorService.searchDebtorPromise(this.customerPuplic_key, this.arrFinalData[i].clientemail, this.arrFinalData[i].clientid.toString());
        debtorPromiseResult.then(
          this.bindInvoiceDetails.bind(this, [this.arrFinalData[i], i])
        ).catch(error => {
            this.failureInvoiceDetails(error.error, this.arrFinalData[i],i);
          });
      }
    }
    this.tab3Error = false;
    this.tab3();

  }

  bindInvoiceDetails(arrParams: any, searchDebtorResult: any) {
    var invoiceObj = {} as Invoice;
    invoiceObj.total = {} as Amount;
    invoiceObj.metadata = {} as Order;
    invoiceObj.debtor = {} as Debtor;
    invoiceObj.user = {} as User;

    invoiceObj.invoice_id = arrParams[0].external_id.toString();
    invoiceObj.user.public_id = this.user_public_id;
    invoiceObj.metadata.order_id = arrParams[0].order_id.toString();
    invoiceObj.metadata.order_name = arrParams[0].name;
    invoiceObj.metadata.order_description = arrParams[0].order_description;
    invoiceObj.debtor.public_id = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.public_id;
    invoiceObj.debtor.document_id = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.document_id;
    invoiceObj.debtor.document_type = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.document_type;
    invoiceObj.debtor.email = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.email;
    invoiceObj.debtor.external_id = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.external_id;
    invoiceObj.debtor.name = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.name;
    invoiceObj.debtor.phone = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.phone;
    invoiceObj.debtor.status = (searchDebtorResult == undefined || searchDebtorResult == null || searchDebtorResult == '') ? '' : searchDebtorResult.status;
    
    invoiceObj.total.currency = arrParams[0].currency;
    invoiceObj.total.value = (arrParams[0].value == undefined || arrParams[0].value == null || arrParams[0].value == '') ? 0 : Number(arrParams[0].value);


    var due_datetime_momentobj = moment(arrParams[0].due_datetime, 'DD/MM/YYYY');
    var temp_dueDate = due_datetime_momentobj.format("YYYY-MM-DD 00:00:00");
    invoiceObj.due_datetime = this.convertGMTTime(temp_dueDate);

    // var tmpdue_Date = new Date(arrParams[0].due_datetime);
    // invoiceObj.due_datetime = tmpdue_Date.toISOString();

    var exp_datetime_momentobj = moment(arrParams[0].expiration_datetime, 'DD/MM/YYYY');
    var temp_expDate = exp_datetime_momentobj.format("YYYY-MM-DD 00:00:00");
    invoiceObj.expiration_datetime = this.convertGMTTime(temp_expDate);

    const invoiceCreditorPromiseResult = this.customerService.getCustomerAccountListPromise(this.customerPuplic_key);
    invoiceCreditorPromiseResult.then(
      this.bindInvoiceDetailsAll.bind(this, [invoiceObj, arrParams[1]])
    ).catch(error => {});
  }

  bindInvoiceDetailsAll(value1: any, customerAccListResult: any) {
    var invoiceObj = {} as Invoice;
    var creditor_account = {} as Account;
    invoiceObj = value1[0];


    var cusAccountPublicKey_temparr = customerAccListResult;
    cusAccountPublicKey_temparr = cusAccountPublicKey_temparr.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));
    cusAccountPublicKey_temparr = cusAccountPublicKey_temparr.filter((t => t.balance.currency == value1[0].total.currency));

    if(cusAccountPublicKey_temparr.length > 0) {
    var cusAccountPublicKey_temp = cusAccountPublicKey_temparr[0].public_id;
    creditor_account.public_id = cusAccountPublicKey_temp;
    invoiceObj.creditor_account = creditor_account;

    const invoiceCreatePromiseResult = this.invoicesService.createInvoicePromise(invoiceObj);
    invoiceCreatePromiseResult.then(
      this.successInvoiceDetails.bind(this, [invoiceObj, value1[1]])
    ).catch(error => {
        this.failureInvoiceDetails(error.error, invoiceObj,value1[1]);
      });
    } else {
      this.failureInvoiceDetails('Accounts not available', invoiceObj,value1[1]);
    }
  }

  /****GMT Converstion */
  convertGMTTime(convertDate) {
    var dateTimeZoneDiff = convertDate.split(/[- :]/),
      startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
    if (this.offsetTimeZone > 0) {
      this.offsetMinutes = 30;
      var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);
      let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
      return tempDate;
    }
    else {
      var startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
      var startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));
      let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
      return tempDate1;
    }
  }

  failureInvoiceDetails(errorValue:any, invoiceobj: any, ivalue:any){
    this.rowNotProcessedCount++;
  }

  successInvoiceDetails(arrparams: any, createdinvoice: any) {
    this.rowProcessedCount++;
    this.bindInvoiceDetailsExcelData('SI','Invoice Created', arrparams[1]);
  }

  bindInvoiceDetailsExcelData(status: any, statusText: any, ivalue: any) {
    var tempInvoiceObj = this.keyChangedData[ivalue] 
    tempInvoiceObj['processed'] = status;
    tempInvoiceObj['statustext'] = statusText
    this.arrFinalDataWithStatus.push(tempInvoiceObj);
    if(this.keyChangedData.length == this.arrFinalDataWithStatus.length){
      setTimeout(() => {
        this.spinnerService.hide();
      },3000)
    }
  }

  downloadResultAsXLSX() {
    this.setExportExcelFileData(this.arrFinalDataWithStatus);
  }

  downloadInvalidExcelResultAsXLSX(){
    this.setValidationExportExcelFileData(this.arrFinalData);
  }

  setValidationExportExcelFileData(excelExportData){
    var excelHeaders = ['ITEM','ID ORDEN DE PAGO', 'REFERENCIA', 'NOMBRE', 'DESCRIPCION', 'ID CLIENTE (*)', 'EMAIL DEL CLIENTE (*)', 'MONEDA', 'MONTO', 'VENCIMIENTO', 'EXPIRACION'];
    var arrFinalDatas = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];
    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      columnsKeyNames = Object.keys(singleRec_temp);
      var externalid_temp = "";
      var orderid_temp = "";
      var name_temp = "";
      var description_temp = "";
      var clientid_temp = "";
      var email_temp = "";
      var currency_temp = "";
      var value_temp = "";
      var duedate_temp = "";
      var expdate_temp = "";
      var item_temp = "";
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == "item") {
          item_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "external_id") {
          externalid_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "order_id") {
          orderid_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "name") {
          name_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "order_description") {
          description_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "clientid") {
          clientid_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "clientemail") {
          email_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "currency") {
          currency_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "value") {
          value_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "due_datetime") {
          duedate_temp = singleRec_temp[columnsKeyNames[j]];
        }

        else if (columnsKeyNames[j] == "expiration_datetime") {
          expdate_temp = singleRec_temp[columnsKeyNames[j]];
        }
      }
      arrFinalDatas.push([item_temp,externalid_temp,orderid_temp,name_temp,description_temp,clientid_temp,email_temp,currency_temp,value_temp,duedate_temp,expdate_temp])
    }
    this.excelService.generateExcelForInvalidData(excelHeaders,arrFinalDatas,"InvoiceImportInvalidData")
  }

  setExportExcelFileData(excelExportData) {
    var excelHeader = ["ID ORDEN DE PAGO", "REFERENCIA", "NOMBRE", "DESCRIPCION", "ID CLIENTE (*)", "EMAIL DEL CLIENTE (*)", "MONEDA", "MONTO", "VENCIMIENTO", "EXPIRACION", "PROCESADO", "ESTADO"]
    var jsonObjectKeys = ['external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime', 'processed', 'statustext']
    var arrFinalData = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];
    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      var externalid_temp;
      var orderid_temp;
      var name_temp;
      var description_temp;
      var clientid_temp;
      var email_temp;
      var currency_temp;
      var value_temp;
      var duedate_temp;
      var expdate_temp;
      var processstatus_temp;
      var status_temp;
      columnsKeyNames = Object.keys(singleRec_temp);
      object_temp = {};
      for (var j = 0; j < columnsKeyNames.length; j++) {

        if (jsonObjectKeys[j] == "external_id") {
          externalid_temp = singleRec_temp[jsonObjectKeys[j]];
        }
        if (jsonObjectKeys[j] == "order_id") {
          orderid_temp = singleRec_temp[jsonObjectKeys[j]];
        }
        if (jsonObjectKeys[j] == "name") {
          name_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "order_description") {
          description_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "clientid") {
          clientid_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "clientemail") {
          email_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "currency") {
          currency_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "value") {
          value_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "due_datetime") {
          duedate_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "expiration_datetime") {
          expdate_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "processed") {
          processstatus_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "statustext") {
          status_temp = singleRec_temp[jsonObjectKeys[j]];
        }

      }

      for (var m = 0; m < excelHeader.length; m++) {
        if (excelHeader[m] == "ID EMPRESA" || excelHeader[m] == "ID ORDEN DE PAGO") {
          object_temp[excelHeader[m]] = externalid_temp;
        }

        if (excelHeader[m] == "REFERENCIA") {
          object_temp[excelHeader[m]] = orderid_temp;
        }

        if (excelHeader[m] == "NOMBRE") {
          object_temp[excelHeader[m]] = name_temp;
        }
        if (excelHeader[m] == "DESCRIPCION") {
          object_temp[excelHeader[m]] = description_temp;
        }

        if (excelHeader[m] == "ID CLIENTE (*)") {
          object_temp[excelHeader[m]] = clientid_temp;
        }

        if (excelHeader[m] == "EMAIL DEL CLIENTE (*)") {
          object_temp[excelHeader[m]] = email_temp;
        }

        if (excelHeader[m] == "MONEDA") {
          object_temp[excelHeader[m]] = currency_temp;
        }

        if (excelHeader[m] == "MONTO") {
          object_temp[excelHeader[m]] = value_temp;
        }
        if (excelHeader[m] == "VENCIMIENTO") {
          object_temp[excelHeader[m]] = duedate_temp;
        }


        if (excelHeader[m] == "EXPIRACION") {
          object_temp[excelHeader[m]] = expdate_temp;
        }


        if (excelHeader[m] == "PROCESADO") {
          object_temp[excelHeader[m]] = processstatus_temp;
        }

        if (excelHeader[m] == "ESTADO") {
          object_temp[excelHeader[m]] = status_temp;
        }
      }//end for

      arrFinalData.push(object_temp);
    }


    this.excelService.exportAsExcelFile(arrFinalData, 'ImportedInvoiceList');


  }
  GetCustomerDetails() {
    this.customerService.getCustomerDebtorsForImport(this.customerPuplic_key).subscribe(data => {
      let resources = data["body"]["data"];
      this.customerList = resources;
    },
      error => {
        console.log('Failed while trying to the Customer Search All Result. ' + error.error);
      });
  }
}